const defaultSearchOptions = [
  {
    // 1
    key: 'productCategoryIdList',
    value: [],
    label: '擅长类目',
    placeholder: '全部',
    type: 'cascader',
    options: [],
    showAllLevels: false,
    props: {
      checkStrictly: true,
      value: 'id',
      label: 'label',
      multiple: true,
      children: 'children',
    },
  },
  {
    // 1
    key: 'contactUserIdList',
    value: [],
    label: '对接采购',
    placeholder: '请选择',
    type: 'select',
    multiple: true,
    options: [],
  },
  {
    // 3
    key: 'supplierCode',
    value: '',
    label: '供应商编码',
    placeholder: '请输入',
    maxlength: 30,
    type: 'input',
  },
  {
    // 3
    key: 'supplierName',
    value: '',
    label: '供应商名称',
    placeholder: '请输入',
    maxlength: 100,
    type: 'input',
  },
  {
    // 3
    key: 'shortName',
    value: '',
    label: '供应商简称',
    placeholder: '请输入',
    maxlength: 30,
    type: 'input',
  },
]

export { defaultSearchOptions }
